export const getProof = async (userAddress: string) => {
  let url = `https://8bhmkpeoqh.execute-api.ap-northeast-1.amazonaws.com/stag/api/v2/whitelist/6b429bf1-0b60-47d1-8b04-ac834a395205/merkleproof?client_addr=${userAddress}`;

  const options = {
    method: "get",
  };

  const result = await fetch(url, options);
  const resultJson = await result.json();
  // Succeed
  if (result.status === 200) {
    return resultJson.proof;
  }
  // Failed
  throw new Error(resultJson.error);
};

export const waitForTransaction = async (provider: any, hash: string) => {
  const res = await provider.waitForTransaction(hash);
  return res;
};

export const getSlicedAddress = (address: string) =>
  `${address.slice(0, 6)}...${address.slice(
    address.length - 4,
    address.length
  )}`;

export function getIsMetaMask(): boolean {
  return window.ethereum?.isMetaMask ?? false;
}

export function getIsInjected(): boolean {
  return Boolean(window.ethereum);
}

export const toHex = (num: number) => {
  const val = Number(num);
  return "0x" + val.toString(16);
};
